export const INIT_GENERAL_SETTINGS = 'init_general_settings';
export const UPDATE_GENERAL_SETTINGS = 'update_general_settings';
